/** Who opened quick capture and with what preset. One overlay for the whole desk. */
import { useSyncExternalStore } from 'react';

export interface CapturePreset {
  accountId?: string;
  draftId?: string;
  phone?: string;
  /** The Dialpad root call the ticket is logged from (a call card or the after-call prompt). */
  rootCallId?: string;
  /** Who answered that call, when it was someone with a desk profile: the ticket is offered to them. */
  answeredBy?: { profileId: string; name: string };
}

export interface CaptureState {
  open: boolean;
  /** Increments on every open so the form starts clean. */
  session: number;
  preset: CapturePreset;
  lastLogged: { ticketId: string; ticketNumber: string; at: number } | null;
}

let state: CaptureState = { open: false, session: 0, preset: {}, lastLogged: null };
const listeners = new Set<() => void>();
const set = (next: CaptureState) => {
  state = next;
  for (const fn of listeners) fn();
};

export function openCapture(preset: CapturePreset = {}): void {
  set({ ...state, open: true, session: state.session + 1, preset });
}

export function closeCapture(): void {
  set({ ...state, open: false });
}

export function captureLogged(ticketId: string, ticketNumber: string): void {
  set({ ...state, open: false, lastLogged: { ticketId, ticketNumber, at: Date.now() } });
}

export function dismissLogged(): void {
  set({ ...state, lastLogged: null });
}

export function useCaptureState(): CaptureState {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => state,
    () => state,
  );
}
